/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ project: NonNullable<unknown> }} Delete_Scene_Description_Job_TextInputs */



/**
* | output |
* | --- |
* | "Are you sure you want to delete this shot description job for {project}?" |
*
* @param {Delete_Scene_Description_Job_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const delete_scene_description_job_text = /** @type {((inputs: Delete_Scene_Description_Job_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Delete_Scene_Description_Job_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Êtes-vous sûr de vouloir supprimer cette description de prise de vue pour ${i?.project} ?`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Möchten Sie diesen Shot-Beschreibungsauftrag für ${i?.project} wirklich löschen?`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Sei sicuro di voler eliminare questa descrizione dell'inquadratura per ${i?.project}?`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Вы уверены, что хотите удалить это задание по описанию съемки для ${i?.project}?`)
	if (locale === "es") return /** @type {LocalizedString} */ (`¿Está seguro de que desea eliminar esta descripción de trabajo de disparo para ${i?.project}?`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`您确定要删除 ${i?.project} 的此镜头描述作业吗？`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.project} のこの撮影説明を削除してもよろしいですか？`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`क्या आप वाकई ${i?.project} के लिए इस शॉट डिस्क्रिप्शन जॉब को डिलीट करना चाहते हैं?`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Tem certeza de que deseja excluir esta descrição de disparo para ${i?.project}?`)
	return /** @type {LocalizedString} */ (`Are you sure you want to delete this shot description job for ${i?.project}?`)
});